import React, { Component } from 'react';
import { BrowserRouter, Link, Route, Switch, Redirect } from 'react-router-dom';
//pages
import Inicio from './pages/Inicio';
import TerminosCondiciones from './pages/TerminosCondiciones';
import PoliticaPrivacidad from './pages/PoliticaPrivacidad';

class App extends Component{

  constructor(props){
    super(props)
    this.state = {

    }
  }


  render () {
    
    return (
        <BrowserRouter>
              <Switch>
                <Route 
                  exact path="/"
                  render={() => <Inicio />}
                />
                <Route 
                  exact path="/terminosycondiciones"
                  render={() => <TerminosCondiciones />}
                />
                <Route 
                  exact path="/politicaprivacidad"
                  render={() => <PoliticaPrivacidad />}
                />
                
              </Switch>
          </BrowserRouter>
    )
  }
}

export default App;
